export function removeQuotes(inputString: string): string {
  // Use regular expression to remove single and double quotes
  return inputString.replace(/['"]+/g, '')
}
